import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getDCompany = (dCompanyId: number | undefined): Promise<IGetDCompanyViaID> => {
  return axiosDefaultApi.get(`/api/DCompanies/GetDCompanyViaID/${dCompanyId}`);
};

type QueryFnType = typeof getDCompany;

type UseGetDCompanyOptions = {
  dCompanyId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetDCompany = ({ dCompanyId , config }: UseGetDCompanyOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getDCompany_${dCompanyId}`],
    queryFn: () => getDCompany(dCompanyId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Θυγατρικής.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};